module.exports = __webpack_public_path__ + "static/img/registro.aa4d2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registro.png
// module id = ixqg
// module chunks = 9